module.exports = __webpack_public_path__ + "img/silver1.93123c22.png";